import { extendTailwindMerge } from 'tailwind-merge';

import { palmbergTheme } from '@/styles/palmbergTheme';

/**
 * twMerge
 *
 * used for merge conflicts like
 * https://github.com/dcastil/tailwind-merge/issues/583#issuecomment-2927096961
 */
export const twMerge = extendTailwindMerge(
  {
    extend: {
      theme: { text: Object.keys(palmbergTheme?.extend?.fontSize ?? {}) },
    },
  },
  (config) => {
    delete config.conflictingClassGroups['max-w'];
    return config;
  }
);
